/**
 * @generated SignedSource<<73c342861cea3668e2b8a5cc6eaa80b5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomRatesToolbar_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesEditorSettingsMenu_data">;
  readonly " $fragmentType": "RoomRatesToolbar_data";
};
export type RoomRatesToolbar_data$key = {
  readonly " $data"?: RoomRatesToolbar_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesToolbar_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomRatesToolbar_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoomRatesEditorSettingsMenu_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "50a238e0cd21a0ba0faf9ab17677ca97";

export default node;
